<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">

        <div class=" bgWight formStyle posRel uploadDocumenti">
          <div class="headForm">
            <div class="row g-3 ">
              <div class="col-md-3 col-6 order-md-1 float-left">
                <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.svg">
              </div>
              <div class="col-md-3 col-6 order-md-3 float-right imgTitoloDocumento">
                <img src="https://www.rimborsoalvolo.it/cresources/outform/images/dimezzaTempi_small.png">
              </div>
              <div class="col-md-6 col-12 order-md-2">
                <p class="titoloDocumenti"><b>Riduci i tempi di elaborazione 1</b>/3</p>
              </div>

            </div>

          </div>
          <div class="p-4 p-md-4 ">
            <div class="row g-2">
              <div class="form-floating mb-3 col-md-6 fixLabel">
                <div class="g-2">{{ $t('message.st6_nome_label') }} *</div>
                <input type="text" class="form-control" id="passeggeroN" v-model="nome" placeholder="Inserisci il nome"
                       v-bind:class="[v$.nome.required.$invalid  && showerrors ? 'form-error' : '']">
                <label for="passeggeroN">Inserisci il nome</label>
                <div class="error" v-if="v$.nome.required.$invalid  && showerrors">{{ $t('message.st6_nome_required') }}</div>
              </div>
              <div class="col-md-6">
                <div class="form-floating mb-3 fixLabel ">
                  <div class="g-2">{{ $t('message.st6_cognome_label') }} *</div>
                  <input type="text" class="form-control " id="passeggeroC" v-model="cognome" placeholder="Inserisci il cognome"
                         v-bind:class="[v$.cognome.required.$invalid  && showerrors ? 'form-error' : '']">
                  <label for="passeggeroC">Inserisci cognome</label>
                  <div class="error" v-if="v$.cognome.required.$invalid  && showerrors">{{ $t('message.st6_cognome_required') }}</div>
                </div>
              </div>
            </div>
            <div class="row g-2">
              <div class="form-floating mb-3 col-md-6 fixLabel">
                <div class="g-2">{{ $t('message.st6_codicefiscale_label') }} *</div>
                <input type="text" class="form-control" id="passeggeroCf" placeholder="Digita il codice fiscale"  :value="codicefiscale.toUpperCase()" @input="codicefiscale = $event.target.value.toUpperCase()"
                       v-bind:class="[(v$.codicefiscale.requiredIf.$invalid || v$.codicefiscale.minLength.$invalid || v$.codicefiscale.maxLength.$invalid || !codicefiscalevalido) && showerrors ? 'form-error' : '']">
                <label for="passeggeroCf">Digita il codice fiscale</label>
                <div class="error" v-if="v$.codicefiscale.requiredIf.$invalid  && showerrors">{{ $t('message.st6_codicefiscale_required') }}</div>
                <div class="error" v-if="v$.codicefiscale.minLength.$invalid  && showerrors">{{ $t('message.st6_codicefiscale_length') }}</div>
                <div class="error" v-if="v$.codicefiscale.maxLength.$invalid  && showerrors">{{ $t('message.st6_codicefiscale_length') }}</div>
                <div class="error" v-if="!codicefiscalevalido  && showerrors">{{ $t('message.st6_codicefiscale_invalid') }}</div>
                <div class="error" v-if="s_passeggerimaggiorenni.length < 1 && minore">{{ $t('message.st6_codicefiscale_minore') }}</div>
              </div>
              <div class="col-md-6">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="nocf" v-model="straniero">
                  <label class="form-check-label" for="nocf">
                    {{ $t('message.st6_dichiarazione_non_italiano') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row g-2">
              <label for="firma">Firma mandato <a href="#infoFirma" data-bs-toggle="modal" data-target="#infoFirma"><span class="firmaFix">?</span></a></label>
              <VueSignaturePad
                  class="application__signature__pad u-border-1 u-border-grey-30 u-input u-input-rectangle u-white"
                  width="500px"
                  height="300px"
                  ref="pannelloFirma"
              />
              <a href="#" @click="this.$refs.pannelloFirma.clearSignature()">{{ $t('message.st6_cancellafirma') }}</a>
              <div class="error" v-if="firmavuota && showerrors">{{ $t('message.st6_firma_required') }}</div>
            </div>

            <div class="row g-3 mt-2">
              <div class="col-md-4 order-md-3">
                <button type="submit" class="btn styleBtn mb-3 float-end" @click="submit()">Procedi ></button>
              </div>
              <div class="col-md-4 order-md-1">

              </div>
              <div class="col-md-4 order-md-2">

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>

  <trust-pilot></trust-pilot>
  <conteggio-reclami></conteggio-reclami>
  <recensioni-f-b></recensioni-f-b>
  <sezione-a-p-r-a></sezione-a-p-r-a>
  <page-footer></page-footer>
  <popup-firma></popup-firma>
</template>

<script>
import {computed} from "vue";
import {useStore} from "vuex";

import VueSignaturePad from "vue3-signature-pad";
import {verificaCodiceFiscale,verificaSeMinore} from "@/lib/verifiche";
import {submitPasseggero} from "@/lib/submitPasseggero";
import useVuelidate from "@vuelidate/core";
import { required, minLength,maxLength,requiredIf } from "@vuelidate/validators";
import FakeChat from "@/components/FakeChat";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
import PopupFirma from "@/components/PopupFirma";
export default {
  name: "RichiedenteStep6",
  setup(){
    const store = useStore();
    const s_completati = computed(()=>store.state.compilazione.stepcompletati);
    const s_ticketref = computed(()=>store.state.compilazione.tktref);
    const s_ticketid = computed(()=>store.state.compilazione.ticketid);
    const s_passeggeri = computed(()=>store.state.passeggeri.passeggeri);
    const s_passeggerimaggiorenni = computed(()=>store.state.passeggeri.passeggerimaggiorenni);
    const s_nome = computed(() => store.state.richiedente.nome);
    const s_cognome = computed(() => store.state.richiedente.cognome);
    const s_step6_inviato = computed( ()=>store.state.gtmstate.step6inviato);
    return {
      v$: useVuelidate(),
      s_completati,
      s_ticketref,
      s_ticketid,
        s_passeggeri,
      s_passeggerimaggiorenni,
      s_nome,
      s_cognome,
      s_step6_inviato,
      aggiungiPasseggero:(value)=>{
        store.dispatch('passeggeri/commitAggiungiPasseggero',value);
       },
      aggiungiPasseggeriMaggiorenni:(value)=>{
        store.dispatch("passeggeri/commitAggiungiPasseggeriMaggiorenni",value);
      },
      setNextPsgRef:(value)=>{
        store.dispatch("passeggeri/commitSetNextPsgRef",value);
      },
      rimuoviPasseggeroByIndice:(value)=>{
        store.dispatch('passeggeri/actionRimuoviPasseggeroByIndice',value);
      },
      findPasseggeroById:(value)=>{
        return store.getters["passeggeri/findPasseggeroById"]
      },
      setStep6Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio6',true);
      }

    }
  },
  components:{
    VueSignaturePad,
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
    FakeChat,
    PopupFirma
  },
  data(){
    return {
      nome: this.s_passeggeri.length < 1 ? this.s_nome : this.s_passeggeri[0].nome,
      cognome: this.s_passeggeri.length < 1 ? this.s_cognome : this.s_passeggeri[0].cognome,
      codicefiscale: this.s_passeggeri.length < 1 ? '' : this.s_passeggeri[0].cf,
      firma : null,
      straniero : this.s_passeggeri.length < 1 ? false : this.s_passeggeri[0].estero,
      codicefiscalevalido: false,
      minore: false,
      showerrors: false,
      tutor: null,
      firmavuota : false,
      submitAvviato : false,
    }
  },
  validations(){
    return {
      nome: { required },
      cognome: { required },
      codicefiscale: { requiredIf: requiredIf(!this.straniero)  ,
        minLength: minLength(16),
        maxLength: maxLength(16)
      },
    }
  },
  methods: {
    prossimo(){

    },
    gesticiErrori(err){
      console.log(err);
      this.$router.push({name:'error'});
    },
    async submit() {
      if(this.submitAvviato) return;

      if(this.$refs.pannelloFirma.isEmpty()) {
        this.firmavuota = true;
        this.submitAvviato = false;
      }
      const valid = await this.v$.$validate();
      let me = this;
      if(!valid){
        this.showerrors = true;
        this.submitAvviato = false;
        return;
      }
      if(!this.codicefiscalevalido && !this.straniero){
        this.showerrors = true;
        this.submitAvviato = false;
        return;
      }
      if(this.$refs.pannelloFirma.isEmpty()){
        this.firmavuota = true;
        this.showerrors = true;
        this.submitAvviato = false;
        return;
      }
      if(this.minore && this.tutor === null){
        this.submitAvviato = false;
        this.showerrors = true;
        return;
      }
      this.submitAvviato = true;
      let passeggero = {
        nome: this.nome,
        cognome: this.cognome,
        codicefiscale: this.codicefiscale,
        firma: this.$refs.pannelloFirma.toDataURL(),
        firmaData: btoa(JSON.stringify(this.$refs.pannelloFirma.toData())),
        idtutor: null,
        estero: this.straniero,
        minore : this.minore
      }

      submitPasseggero(this.s_ticketref,passeggero).then((res)=>{
        if(res.data.STATUS === "OK"){
          let index2 =   me.s_passeggeri.find(function(obj){
            return obj.id === res.data.PSGREF;
          })
         let index3 =  me.s_passeggeri.map(item=>item.id).indexOf(res.data.PSGREF);


          if(index3 > -1) {
            me.rimuoviPasseggeroByIndice(index3);
          }

          me.aggiungiPasseggero({"id":res.data.PSGREF,"nome":me.nome,"cognome":me.cognome,"minore":me.minore,"cf":me.codicefiscale,"estero":me.straniero});
         if(me.s_passeggerimaggiorenni.indexOf(res.data.PSGREF) < 0 )
          me.aggiungiPasseggeriMaggiorenni(res.data.PSGREF);

          me.setNextPsgRef(res.data.PSGREF);
          this.$router.push({name:'step7'});
        }else{

          me.submitAvviato = false;
          me.gesticiErrori(res.data);
        }
      }).catch((err)=>{
        console.log(err);
        me.submitAvviato = false;
        this.$router.push({name:'error'});
      })
    }
  },
  mounted(){
    if(this.s_ticketref === null){
      this.$router.push({name:'step1'});
    }else{
      // eslint-disable-next-line
      window.scrollTo(0,0);

      if(!this.s_step6_inviato) {
        this.setStep6Inviato();
        this.$gtm.trackEvent({
              event: 'step_visitato',
              value: 6,
            }
        );

      }


      if(this.codicefiscale === '' || this.codicefiscale === null) return;
      this.codicefiscalevalido = verificaCodiceFiscale(this.codicefiscale,this.nome,this.cognome);
    }


  },
  watch: {
    codicefiscale(newvalue){
      if(newvalue.length !== 16) return;
        this.codicefiscalevalido = verificaCodiceFiscale(newvalue,this.nome,this.cognome);
        this.minore = verificaSeMinore(newvalue);
    }
  }

}
</script>

<style scoped>
.application__signature__pad {
  height: 300px;
  border: 1px #000000 solid;
}


</style>